import AppRouter from './router/Router.jsx';
function App() {
  return (
    <div className="App">
      <h1 className='text-blue-500'>
        <AppRouter />
      </h1>
      <div className="toast-container fixed top-0 right-0 !p-0 !m-0 z-[9999999]" />
    </div>
  );
}

export default App;
